export default __webpack_public_path__ + "static/media/camera.4e9ff9ed.png";